import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { connect } from 'react-redux';
import DepositFormSC, {
  DepositFormTextInputSC,
  DepositFormTextErrorSC,
} from './deposit-form.styled';
import { Formik, Form } from 'formik';
import { SmallText, BodyText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage, useIntl } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { QRCode } from 'react-qrcode-logo';
import InlineLoading from '../../ui/inline-loading';
import logo_symbol from '../../../assets/img/svg/wishmaker-logo-bg-white.png';
import depositFormSchema, { formInitialValues, amountValidationRule } from './deposit-form.schema';

const DepositForm = ({
  userData,
  codeString,
  codeStringError,
  getDepositQrCodeString,
  resetDepositQrCodeString,
}) => {
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();
  const timer = React.useRef(null);

  const onAmountChange = (value) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (value.length && amountValidationRule.isValidSync(value)) {
      setLoading(true);
      timer.current = setTimeout(() => {
        getDepositQrCodeString({
          data: {
            amount: value,
          },
        });
      }, 500);
    } else {
      resetDepositQrCodeString();
      setLoading(false);
    }
  };

  return (
    <>
      <DepositFormSC>
        <div className="row">
          <div className="half-block">
            <SmallText className="black-transparent block">
              <FormattedMessage
                id="onboarding_deposit_investor_iban_label"
                defaultMessage={dlt['onboarding_deposit_investor_iban_label']}
              />
            </SmallText>

            <BodyText className="bolder block">
              <FormattedMessage
                id="onboarding_deposit_investor_iban"
                defaultMessage={dlt['onboarding_deposit_investor_iban']}
              />
            </BodyText>
            <SmallText className="black-transparent block margin-top-15">
              <FormattedMessage
                id="onboarding_deposit_investor_variable_symbol"
                defaultMessage={dlt['onboarding_deposit_investor_variable_symbol']}
              />
            </SmallText>
            <BodyText className="bolder block">{userData.wm_number}</BodyText>
            <Formik
              enableReinitialize
              initialValues={formInitialValues}
              validationSchema={depositFormSchema}
            >
              {({ values, errors, setFieldValue, handleBlur }) => {
                const amountHasError = errors && errors.amount;
                return (
                  <Form>
                    <SmallText className="black-transparent block margin-top-15">
                      <FormattedMessage
                        id="onboarding_deposit_investor_amount_label"
                        defaultMessage={dlt['onboarding_deposit_investor_amount_label']}
                      />
                    </SmallText>
                    <DepositFormTextInputSC
                      type="number"
                      name="amount"
                      placeholder={formatMessage({
                        id: 'onboarding_deposit_investor_amount_label',
                      })}
                      hasError={amountHasError}
                      onChange={(e) => {
                        setFieldValue('amount', e.target.value);
                        onAmountChange(e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.amount || ''}
                    />
                    {amountHasError ? (
                      <DepositFormTextErrorSC>{errors.amount}</DepositFormTextErrorSC>
                    ) : null}
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="half-block centered">
            {codeStringError ? (
              <div className="qr-code-placeholder p5">
                <FormattedHTMLMessage
                  id="onboarding_deposit_investor_qr_code_error"
                  defaultMessage={dlt['onboarding_deposit_investor_qr_code_error']}
                />
              </div>
            ) : codeString ? (
              <QRCode logoWidth="35" logoImage={logo_symbol} value={codeString} />
            ) : (
              <div className="qr-code-placeholder">
                {loading ? (
                  <InlineLoading />
                ) : (
                  <FormattedMessage
                    id="onboarding_deposit_investor_qr_code_placeholder"
                    defaultMessage={dlt['onboarding_deposit_investor_qr_code_placeholder']}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </DepositFormSC>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDepositQrCodeString: ActionCreators.getDepositQrCodeString,
      resetDepositQrCodeString: ActionCreators.resetDepositQrCodeString,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user,
    codeString: state.deposits.qrCodeString,
    codeStringError: state.deposits.qrCodeStringError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositForm);
